














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Scroller from "@/components/Scroller/Scroller.vue";
import { GETTER_LOGIN_INS_USER_LIST } from "@/store/constants/ins_user_info_types";
import { Getter } from "vuex-class";
import CountDownTime from "@/components/CountDownTime/CountDownTime.vue";
import {
  act_users_getters,
  act_users_mutation
} from "@/services/earn_coins/observer/act_users_observer";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
import { act_users_exception_status } from "@/services/earn_coins/earn_coins_consts/earn_coins_consts";
@Component({
  components: { Scroller, CountDownTime, ImgFetched }
})
export default class EarnUserList extends Vue {
  @Getter(GETTER_LOGIN_INS_USER_LIST)
  private logginedInsUserList: any;
  @Prop({ default: "" })
  private currentEarnCoinsUserId!: string;
  @Prop({ default: false })
  private show!: boolean;

  get earnCoinsUserList() {
    return this.logginedInsUserList.map((logginedUser: any) => {
      const loggined_user_id = logginedUser.user_id;
      const find_act_user = act_users_getters.get_act_user(loggined_user_id);
      console.log("find_act_user:", find_act_user);
      const act_user_status = act_users_exception_status(find_act_user);
      return {
        ...logginedUser,
        ...act_user_status
      };
    });
  }

  get countDownStyle() {
    return {
      color: "rgb(163,163,163)",
      fontSize: "12px",
      background: "none"
    };
  }

  private countDownTimeEnded(item: any) {
    // 倒计时结束，需要刷新当前的user_list的ui
    const { user_id } = item;
    act_users_mutation.update_act_user(user_id, {
      is_act_limited: false,
      end_limit_time_stamp: 0
    });
  }

  private countDownShow(item: any) {
    const { end_limit_time_stamp } = item;
    if (end_limit_time_stamp && end_limit_time_stamp > new Date().valueOf()) {
      return true;
    } else {
      return false;
    }
  }

  private sortIconClass(item: any) {
    const { color_status } = item;
    return color_status;
  }

  private clickItem(id: string) {
    this.$emit("clickItem", id);
  }

  get itemListHeight() {
    return 96 * this.earnCoinsUserList.length;
  }
}
